import { END_POINT } from "constants/Api";
import { getUrl } from "utils/Utils";
import api from "./Instance";

export const getDownloadGeoJSON = async (requestId: number) => {
    return await api.get<Blob>(`${getUrl(END_POINT.DOWNLOAD_GEOJSON)}/${requestId}`, { responseType: 'blob'});
};
